import React from 'react';
import { Stack, Select, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGlobalTheme } from '../../contexts/ThemeContext';

export default function LanguageSelector() {
  const { t } = useTranslation();
  const { language, setGlobalLanguage } = useGlobalTheme();

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
        {t('language.label')}
      </Typography>
      <Select
        size="small"
        value={language}
        onChange={(e) => setGlobalLanguage(e.target.value)}
        sx={{
          minWidth: 120,
          bgcolor: 'background.paper',
          fontSize: '0.875rem',
          '.MuiSelect-select': { py: 0.75, px: 1.5 }
        }}
      >
        <MenuItem value="zh-tw" sx={{ fontSize: '0.875rem' }}>繁體中文</MenuItem>
        <MenuItem value="en" sx={{ fontSize: '0.875rem' }}>English</MenuItem>
      </Select>
    </Stack>
  );
}
